import type { OnboardingStep } from './types.d';

export const EVENT_LABEL_SCREEN_2 = '/fcg26/2screengame';
export const EVENT_LABEL_SCREEN_3 = '/fcg26/3screengame';

export const ACTION_BY_KEY_SCREEN_1: Record<string, string> = {
  surveystep1Option1: '/fcg26/familie',
  surveystep1Option2: '/fcg26/date love partner',
  surveystep1Option3: '/fcg26/maatjes&besties',
  surveystep1Option4: '/fcg26/onze tieners',
  surveystep1Option5: '/fcg26/kids kleinkinderen',
};

export const ACTION_BY_KEY_SCREEN_2: Record<string, string> = {
  surveystep2Option1: '/fcg26/fun met de kids',
  surveystep2Option2: '/fcg26/ff lekker snel snacken',
  surveystep2Option3: '/fcg26/gezellig met de fam',
  surveystep2Option4: '/fcg26/had t weer ff nodig',
};

export const PLEXURE_TAG_BY_OPTION_KEY: Partial<Record<string, string>> = {
  surveystep1Option1: 'NL_Custom_111',
  surveystep1Option2: 'NL_Custom_112',
  surveystep1Option3: 'NL_Custom_113',
  surveystep1Option4: 'NL_Custom_114',
  surveystep1Option5: 'NL_Custom_115',
  surveystep2Option1: 'NL_Custom_116',
  surveystep2Option2: 'NL_Custom_117',
  surveystep2Option3: 'NL_Custom_118',
  surveystep2Option4: 'NL_Custom_119',
};

export const STEPS: OnboardingStep[] = [
  {
    type: 'survey',
    questionKey: 'surveystep1Question',
    optionKeys: [
      'surveystep1Option1',
      'surveystep1Option2',
      'surveystep1Option3',
      'surveystep1Option4',
      'surveystep1Option5',
    ],
  },
  {
    type: 'survey',
    questionKey: 'surveystep2Question',
    optionKeys: [
      'surveystep2Option1',
      'surveystep2Option2',
      'surveystep2Option3',
      'surveystep2Option4',
    ],
    hasTerms: true,
  },
  {
    type: 'instruction',
  },
];
